var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurkey1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.85,10.755a5.038,5.038,0,0,0-.17-3.03c.038-.012,1.482-1.481,1.513-1.5a1.5,1.5,0,1,0,.649-2.063,1.5,1.5,0,1,0-2.063.649c-.015.022-1.5,1.482-1.5,1.507-1.424-.764-4.375,0-6.134.964C6.193,5.8.029,9.471,0,16v2.568a5.026,5.026,0,0,0,4.3,4.951C10.447,24.5,23.753,24.34,24,18,24,15.553,22.448,12.867,19.85,10.755ZM14.643,8.388c1.435-.481,2.635-.516,3.06-.092.965.965-.563,5.139-2.181,6.757C12.461,18,8,13.538,10.947,10.478A10.574,10.574,0,0,1,14.643,8.388ZM9,22a36.975,36.975,0,0,1-4.419-.461A3.015,3.015,0,0,1,2,18.568V16A6.956,6.956,0,0,1,9.571,9.03c-5.795,6.95,5.914,14.078,9.632,3.8C26.5,20.17,18.3,21.918,9,22ZM7,3V1A1,1,0,0,1,9,1V3A1,1,0,0,1,7,3Zm4,0V1a1,1,0,0,1,2,0V3A1,1,0,0,1,11,3ZM3,3V1A1,1,0,0,1,5,1V3A1,1,0,0,1,3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey1);
export default __webpack_public_path__ + "static/media/turkey (1).ff86f3c3f28c466820612d153f8b6fd1.svg";
export { ForwardRef as ReactComponent };